export default __webpack_public_path__ + "static/media/a3.d58c8edd.png";